import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import styles from './Input.module.css';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, error, className, id, rows = 4, ...rest },
  ref,
) {
  const taId = id ?? rest.name;
  return (
    <label className={styles.wrapper} htmlFor={taId}>
      {label ? <span className={styles.label}>{label}</span> : null}
      <textarea
        ref={ref}
        id={taId}
        rows={rows}
        className={[styles.input, className].filter(Boolean).join(' ')}
        {...rest}
      />
      {error ? <span className={styles.error}>{error}</span> : null}
    </label>
  );
});
